export enum Color {
  PRIMARY = "primary",
  SECONDARY = "secondary"
}

export enum Size {
  SMALL = "small",
  LARGE = "large"
}

export enum Variant {
  CONTAINED = "contained",
  OUTLINED = "outlined",
  TEXT = "text",
  INFO = "info"
}
